import React from 'react';
import { Navigation } from 'configurable-form/shared/navigation';

export function ExistingLicensesNavigation(props) {
  return (
    <Navigation {...props} continueButtonType="button" />
  )
}
